export const workTypes = [
  'FULL_TIME',
  'PART_TIME',
  'CONTRACT',
  'VOLUNTEER',
  // 'freelance',
  // 'internship',
  // 'temporary',
  // 'seasonal',
  // 'apprenticeship',
  // 'self-employed',
  // 'shift-work',
  // 'zero-hours',
];

export const workLocation = [
  'OFFICE',
  'REMOTE',
  // 'hybrid',
  // 'flexible',
  // 'mobile',
  // 'client-sites',
  // 'co-working-space',
  // 'international',
];

export const relationship = [
  'father',
  'mother',
  'son',
  'daughter',
  'brother',
  'sister',
  'husband',
  'wife',
  'grandfather',
  'grandmother',
  'grandson',
  'granddaughter',
  'uncle',
  'aunt',
  'nephew',
  'niece',
  'cousin',
  'father-in-law',
  'mother-in-law',
  'brother-in-law',
  'sister-in-law',
  'son-in-law',
  'daughter-in-law',
  'stepfather',
  'stepmother',
  'stepson',
  'stepdaughter',
  'stepbrother',
  'stepsister',
  'partner',
  'spouse',
  'boyfriend',
  'girlfriend',
  'fiancé',
  'fiancée',
  'guardian',
  'ward',
  'friend',
  'roommate',
  'colleague',
  'mentor',
  'caregiver',
  'other',
];
export const genders = ['MALE', 'FEMALE'];

export const maritalStatus = ['SINGLE', 'MARRIED', 'DIVORCED', 'WIDOWED'];

export const nationality = [
  'Afghan',
  'Albanian',
  'Algerian',
  'Andorran',
  'Angolan',
  'Argentine/Argentinian',
  'Armenian',
  'Australian',
  'Austrian',
  'Azerbaijani',
  'Bahamian',
  'Bahraini',
  'Bangladeshi',
  'Barbadian',
  'Belarusian',
  'Belgian',
  'Belizean',
  'Beninese',
  'Bhutanese',
  'Bolivian',
  'Bosnian/Herzegovinian',
  'Botswanan',
  'Brazilian',
  'Bruneian',
  'Bulgarian',
  'Burkinabé/Burkinabe',
  'Burmese',
  'Burundian',
  'Cambodian',
  'Cameroonian',
  'Canadian',
  'Cape Verdean',
  'Central African',
  'Chadian',
  'Chilean',
  'Chinese',
  'Colombian',
  'Comoran',
  'Congolese',
  'Costa Rican',
  'Croatian',
  'Cuban',
  'Cypriot',
  'Czech',
  'Danish',
  'Djiboutian',
  'Dominican',
  'Dominican (Republic)',
  'Dutch',
  'Ecuadorian',
  'Egyptian',
  'El Salvadoran',
  'Equatorial Guinean',
  'Eritrean',
  'Estonian',
  'Ethiopian',
  'Fijian',
  'Filipino',
  'Finnish',
  'French',
  'Gabonese',
  'Gambian',
  'Georgian',
  'German',
  'Ghanaian',
  'Greek',
  'Grenadian',
  'Guatemalan',
  'Guinean',
  'Guinea-Bissauan',
  'Guyanese',
  'Haitian',
  'Honduran',
  'Hungarian',
  'Icelandic',
  'Indian',
  'Indonesian',
  'Iranian',
  'Iraqi',
  'Irish',
  'Israeli',
  'Italian',
  'Ivorian',
  'Jamaican',
  'Japanese',
  'Jordanian',
  'Kazakhstani',
  'Kenyan',
  'Kittitian/Nevisian',
  'Kosovar',
  'Kuwaiti',
  'Kyrgyzstani',
  'Laotian',
  'Latvian',
  'Lebanese',
  'Liberian',
  'Libyan',
  'Liechtensteiner',
  'Lithuanian',
  'Luxembourger',
  'Macedonian',
  'Malagasy',
  'Malawian',
  'Malaysian',
  'Maldivian',
  'Malian',
  'Maltese',
  'Marshallese',
  'Mauritanian',
  'Mauritian',
  'Mexican',
  'Micronesian',
  'Moldovan',
  'Monégasque/Monacan',
  'Mongolian',
  'Montenegrin',
  'Moroccan',
  'Mozambican',
  'Namibian',
  'Nauruan',
  'Nepalese',
  'Dutch (Netherlands)',
  'New Zealander',
  'Nicaraguan',
  'Nigerien',
  'Nigerian',
  'North Korean',
  'South Korean',
  'Norwegian',
  'Omani',
  'Pakistani',
  'Palauan',
  'Panamanian',
  'Papua New Guinean',
  'Paraguayan',
  'Peruvian',
  'Polish',
  'Portuguese',
  'Qatari',
  'Romanian',
  'Russian',
  'Rwandan',
  'Saint Kitts and Nevisian',
  'Saint Lucian',
  'Saint Vincentian',
  'Samoan',
  'San Marinese',
  'Sao Tomean',
  'Saudi',
  'Senegalese',
  'Serbian',
  'Seychellois',
  'Sierra Leonean',
  'Singaporean',
  'Slovak/Slovakian',
  'Slovenian',
  'Solomon Islander',
  'Somali',
  'South African',
  'South Sudanese',
  'Spanish',
  'Sri Lankan',
  'Sudanese',
  'Surinamese',
  'Swazi',
  'Swedish',
  'Swiss',
  'Syrian',
  'Tajikistani',
  'Tanzanian',
  'Thai',
  'Togolese',
  'Tongan',
  'Trinidadian/Tobagonian',
  'Tunisian',
  'Turkish',
  'Turkmen',
  'Tuvaluan',
  'Ugandan',
  'Ukrainian',
  'Emirati',
  'British',
  'American',
  'Uruguayan',
  'Uzbekistani',
  'Ni‑Vanuatu',
  'Vaticanian',
  'Venezuelan',
  'Vietnamese',
  'Yemeni',
  'Zambian',
  'Zimbabwean',
];
